import { createSlice, isAnyOf, PayloadAction } from '@reduxjs/toolkit'

import { GiftCardCheckoutPaymentParams, GiftCardsReducerState } from '../types'

import { fetchGiftCardAddon } from './giftCardsThunks'

const initialState: GiftCardsReducerState = {
  giftCardAddon: null,
  giftCardAddonOutlet: null,
  giftCardAddonInitialized: false,

  checkoutPaymentParams: null,
  checkoutCancelModalVisible: false,
}

const giftCardsSlice = createSlice({
  name: 'giftCards',
  initialState,
  reducers: {
    setGiftCardCheckoutPaymentParams(
      state,
      action: PayloadAction<GiftCardCheckoutPaymentParams | null>,
    ) {
      state.checkoutPaymentParams = action.payload
    },
    setGiftCardCheckoutCancelModalVisible(
      state,
      action: PayloadAction<boolean>,
    ) {
      state.checkoutCancelModalVisible = action.payload
    },
    clearGiftCardCheckoutPaymentParams(state) {
      state.checkoutPaymentParams = initialState.checkoutPaymentParams
    },
  },
  extraReducers: builder => {
    builder.addCase(fetchGiftCardAddon.pending, state => {
      state.giftCardAddon = null
      state.giftCardAddonOutlet = null
      state.giftCardAddonInitialized = false
    })

    builder.addCase(fetchGiftCardAddon.fulfilled, (state, action) => {
      state.giftCardAddon = action.payload.giftCardAddOn
      state.giftCardAddonOutlet = action.payload.outlet
    })

    builder.addMatcher(
      isAnyOf(fetchGiftCardAddon.fulfilled, fetchGiftCardAddon.rejected),
      state => {
        state.giftCardAddonInitialized = true
      },
    )
  },
})

export const {
  setGiftCardCheckoutPaymentParams,
  setGiftCardCheckoutCancelModalVisible,
  clearGiftCardCheckoutPaymentParams,
} = giftCardsSlice.actions

export default giftCardsSlice.reducer
